import React from "react";

const TicketCreatedEmail: React.FC = () => {
    const htmlContent = `
        <div class="flex justify-center py-8 bg-gray-100 rounded-lg">
            <div class="max-w-[600px] mx-auto bg-white shadow-lg">
                <div class="bg-gradient-to-r from-blue-600 to-blue-700 px-8 py-6">
                    <h1 class="text-white text-2xl font-semibold">Service Desk</h1>
                </div>
                <div class="px-8 py-6">
                    <h2 class="text-2xl font-semibold text-gray-900 mb-4">Your Request Has Been Received</h2>
                    <p class="text-gray-700 mb-6">Thank you for contacting our Service Desk. We've received your request and a ticket has been created.</p>
                    <div class="border-l-4 p-4 mb-4 bg-blue-50 border-blue-200 text-blue-800">
                        <p class="font-semibold mb-1">Ticket Successfully Created</p>
                        <p class="text-sm">We'll begin working on your request according to its priority level.</p>
                    </div>
                    <div class="bg-gray-50 p-4 rounded-md mb-6">
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Ticket ID:</span>
                            <span class="text-gray-900"><span class="font-mono text-blue-600">#SD-2024-1547</span></span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Subject:</span>
                            <span class="text-gray-900">Unable to access customer database</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Priority:</span>
                            <span class="text-gray-900"><span class="inline-block bg-orange-100 text-orange-800 px-2 py-1 rounded text-sm font-medium">High</span></span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Status:</span>
                            <span class="text-gray-900">To Do</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">SLA Target:</span>
                            <span class="text-gray-900">Response within 4 hours</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Submitted:</span>
                            <span class="text-gray-900">May 6, 2026 at 2:30 PM</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Attachments:</span>
                            <span class="text-gray-900">2 files (screenshot.png, error-log.txt)</span>
                        </div>
                    </div>
                    <div class="mb-6">
                        <h3 class="font-semibold text-gray-900 mb-2">Your Request Details:</h3>
                        <div class="bg-gray-50 p-4 rounded border border-gray-200">
                            <p class="text-gray-700 text-sm">I'm unable to connect to the customer database since this morning. When I try to log in, I receive an "Authentication failed" error. This is blocking my ability to process customer orders.</p>
                        </div>
                    </div>
                    <div class="flex gap-3">
                        <a href="#" class="inline-block bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-md font-medium no-underline transition-colors">View Ticket in Portal</a>
                        <a href="#" class="inline-block bg-gray-600 hover:bg-gray-700 text-white px-6 py-3 rounded-md font-medium no-underline transition-colors">Add More Information</a>
                    </div>
                    <div class="mt-6 pt-6 border-t border-gray-200">
                        <p class="text-sm text-gray-600"><strong>What happens next?</strong> Your ticket will be assigned to the appropriate team member. You'll receive updates via email as progress is made.</p>
                    </div>
                </div>
                <div class="bg-gray-50 px-8 py-6 border-t border-gray-200">
                    <p class="text-sm text-gray-600">This is an automated message from the Service Desk. Please do not reply directly to this email.</p>
                </div>
            </div>
        </div>
    `;

    return (
        <div className="p-4">
            <h1 className="text-xl font-bold mb-4">Email Template Preview: Ticket Created</h1>
            <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
        </div>
    );
};

export default TicketCreatedEmail;
